(("function" != typeof lazySizes && "object" != typeof lazySizes) ||
  "undefined" == typeof lazySizes) &&
  ((function (t, e) {
    var i = (function (t, e) {
      "use strict";
      if (e.getElementsByClassName) {
        var i,
          s,
          a = e.documentElement,
          o = t.Date,
          r = t.HTMLPictureElement,
          l = "addEventListener",
          n = "getAttribute",
          c = t[l],
          p = t.setTimeout,
          d = t.requestAnimationFrame || p,
          u = t.requestIdleCallback,
          f = /^picture$/i,
          m = ["load", "error", "lazyincluded", "_lazyloaded"],
          g = {},
          b = Array.prototype.forEach,
          h = function (t, e) {
            return (
              g[e] || (g[e] = new RegExp("(\\s|^)" + e + "(\\s|$)")),
              g[e].test(t[n]("class") || "") && g[e]
            );
          },
          y = function (t, e) {
            h(t, e) ||
              t.setAttribute("class", (t[n]("class") || "").trim() + " " + e);
          },
          v = function (t, e) {
            var i;
            (i = h(t, e)) &&
              t.setAttribute("class", (t[n]("class") || "").replace(i, " "));
          },
          w = function (t, e, i) {
            var s = i ? l : "removeEventListener";
            i && w(t, e),
              m.forEach(function (i) {
                t[s](i, e);
              });
          },
          T = function (t, s, a, o, r) {
            var l = e.createEvent("Event");
            return (
              a || (a = {}),
              (a.instance = i),
              l.initEvent(s, !o, !r),
              (l.detail = a),
              t.dispatchEvent(l),
              l
            );
          },
          _ = function (e, i) {
            var a;
            !r && (a = t.picturefill || s.pf)
              ? (i &&
                  i.src &&
                  !e[n]("srcset") &&
                  e.setAttribute("srcset", i.src),
                a({ reevaluate: !0, elements: [e] }))
              : i && i.src && (e.src = i.src);
          },
          P = function (t, e) {
            return (getComputedStyle(t, null) || {})[e];
          },
          C = function (t, e, i) {
            for (
              i = i || t.offsetWidth;
              i < s.minSize && e && !t._lazysizesWidth;

            )
              (i = e.offsetWidth), (e = e.parentNode);
            return i;
          },
          S = (function () {
            var t,
              i,
              s = [],
              a = [],
              o = s,
              r = function () {
                var e = o;
                for (o = s.length ? a : s, t = !0, i = !1; e.length; )
                  e.shift()();
                t = !1;
              },
              l = function (s, a) {
                t && !a
                  ? s.apply(this, arguments)
                  : (o.push(s), i || ((i = !0), (e.hidden ? p : d)(r)));
              };
            return (l._lsFlush = r), l;
          })(),
          z = function (t, e) {
            return e
              ? function () {
                  S(t);
                }
              : function () {
                  var e = this,
                    i = arguments;
                  S(function () {
                    t.apply(e, i);
                  });
                };
          },
          F = function (t) {
            var e,
              i = 0,
              a = s.throttleDelay,
              r = s.ricTimeout,
              l = function () {
                (e = !1), (i = o.now()), t();
              },
              n =
                u && r > 49
                  ? function () {
                      u(l, { timeout: r }),
                        r !== s.ricTimeout && (r = s.ricTimeout);
                    }
                  : z(function () {
                      p(l);
                    }, !0);
            return function (t) {
              var s;
              (t = !0 === t) && (r = 33),
                e ||
                  ((e = !0),
                  (s = a - (o.now() - i)) < 0 && (s = 0),
                  t || s < 9 ? n() : p(n, s));
            };
          },
          A = function (t) {
            var e,
              i,
              s = function () {
                (e = null), t();
              },
              a = function () {
                var t = o.now() - i;
                t < 99 ? p(a, 99 - t) : (u || s)(s);
              };
            return function () {
              (i = o.now()), e || (e = p(a, 99));
            };
          };
        !(function () {
          var e,
            i = {
              lazyClass: "lazyload",
              loadedClass: "lazyloaded",
              loadingClass: "lazyloading",
              preloadClass: "lazypreload",
              errorClass: "lazyerror",
              autosizesClass: "lazyautosizes",
              srcAttr: "data-src",
              srcsetAttr: "data-srcset",
              sizesAttr: "data-sizes",
              minSize: 40,
              customMedia: {},
              init: !0,
              expFactor: 1.5,
              hFac: 0.8,
              loadMode: 2,
              loadHidden: !0,
              ricTimeout: 0,
              throttleDelay: 125,
            };
          for (e in ((s = t.lazySizesConfig || t.lazysizesConfig || {}), i))
            e in s || (s[e] = i[e]);
          (t.lazySizesConfig = s),
            p(function () {
              s.init && Q();
            });
        })();
        var k = (function () {
            var r,
              d,
              u,
              m,
              g,
              C,
              k,
              Q,
              U,
              L,
              D,
              x,
              I = /^img$/i,
              E = /^iframe$/i,
              H = "onscroll" in t && !/(gle|ing)bot/.test(navigator.userAgent),
              M = 0,
              O = 0,
              N = -1,
              R = function (t) {
                O--, (!t || O < 0 || !t.target) && (O = 0);
              },
              B = function (t) {
                return (
                  null == x && (x = "hidden" == P(e.body, "visibility")),
                  x ||
                    ("hidden" != P(t.parentNode, "visibility") &&
                      "hidden" != P(t, "visibility"))
                );
              },
              W = function (t, i) {
                var s,
                  o = t,
                  r = B(t);
                for (
                  Q -= i, D += i, U -= i, L += i;
                  r && (o = o.offsetParent) && o != e.body && o != a;

                )
                  (r = (P(o, "opacity") || 1) > 0) &&
                    "visible" != P(o, "overflow") &&
                    ((s = o.getBoundingClientRect()),
                    (r =
                      L > s.left &&
                      U < s.right &&
                      D > s.top - 1 &&
                      Q < s.bottom + 1));
                return r;
              },
              G = function () {
                var t,
                  o,
                  l,
                  c,
                  p,
                  u,
                  f,
                  g,
                  b,
                  h,
                  y,
                  v,
                  w = i.elements;
                if ((m = s.loadMode) && O < 8 && (t = w.length)) {
                  for (o = 0, N++; o < t; o++)
                    if (w[o] && !w[o]._lazyRace)
                      if (!H || (i.prematureUnveil && i.prematureUnveil(w[o])))
                        Y(w[o]);
                      else if (
                        (((g = w[o][n]("data-expand")) && (u = 1 * g)) ||
                          (u = M),
                        h ||
                          ((h =
                            !s.expand || s.expand < 1
                              ? a.clientHeight > 500 && a.clientWidth > 500
                                ? 500
                                : 370
                              : s.expand),
                          (i._defEx = h),
                          (y = h * s.expFactor),
                          (v = s.hFac),
                          (x = null),
                          M < y && O < 1 && N > 2 && m > 2 && !e.hidden
                            ? ((M = y), (N = 0))
                            : (M = m > 1 && N > 1 && O < 6 ? h : 0)),
                        b !== u &&
                          ((C = innerWidth + u * v),
                          (k = innerHeight + u),
                          (f = -1 * u),
                          (b = u)),
                        (l = w[o].getBoundingClientRect()),
                        (D = l.bottom) >= f &&
                          (Q = l.top) <= k &&
                          (L = l.right) >= f * v &&
                          (U = l.left) <= C &&
                          (D || L || U || Q) &&
                          (s.loadHidden || B(w[o])) &&
                          ((d && O < 3 && !g && (m < 3 || N < 4)) ||
                            W(w[o], u)))
                      ) {
                        if ((Y(w[o]), (p = !0), O > 9)) break;
                      } else
                        !p &&
                          d &&
                          !c &&
                          O < 4 &&
                          N < 4 &&
                          m > 2 &&
                          (r[0] || s.preloadAfterLoad) &&
                          (r[0] ||
                            (!g &&
                              (D ||
                                L ||
                                U ||
                                Q ||
                                "auto" != w[o][n](s.sizesAttr)))) &&
                          (c = r[0] || w[o]);
                  c && !p && Y(c);
                }
              },
              $ = F(G),
              q = function (t) {
                var e = t.target;
                e._lazyCache
                  ? delete e._lazyCache
                  : (R(t),
                    y(e, s.loadedClass),
                    v(e, s.loadingClass),
                    w(e, X),
                    T(e, "lazyloaded"));
              },
              V = z(q),
              X = function (t) {
                V({ target: t.target });
              },
              J = function (t) {
                var e,
                  i = t[n](s.srcsetAttr);
                (e = s.customMedia[t[n]("data-media") || t[n]("media")]) &&
                  t.setAttribute("media", e),
                  i && t.setAttribute("srcset", i);
              },
              K = z(function (t, e, i, a, o) {
                var r, l, c, d, m, g;
                (m = T(t, "lazybeforeunveil", e)).defaultPrevented ||
                  (a &&
                    (i ? y(t, s.autosizesClass) : t.setAttribute("sizes", a)),
                  (l = t[n](s.srcsetAttr)),
                  (r = t[n](s.srcAttr)),
                  o && (d = (c = t.parentNode) && f.test(c.nodeName || "")),
                  (g = e.firesLoad || ("src" in t && (l || r || d))),
                  (m = { target: t }),
                  y(t, s.loadingClass),
                  g && (clearTimeout(u), (u = p(R, 2500)), w(t, X, !0)),
                  d && b.call(c.getElementsByTagName("source"), J),
                  l
                    ? t.setAttribute("srcset", l)
                    : r &&
                      !d &&
                      (E.test(t.nodeName)
                        ? (function (t, e) {
                            try {
                              t.contentWindow.location.replace(e);
                            } catch (i) {
                              t.src = e;
                            }
                          })(t, r)
                        : (t.src = r)),
                  o && (l || d) && _(t, { src: r })),
                  t._lazyRace && delete t._lazyRace,
                  v(t, s.lazyClass),
                  S(function () {
                    var e = t.complete && t.naturalWidth > 1;
                    (g && !e) ||
                      (e && y(t, "ls-is-cached"),
                      q(m),
                      (t._lazyCache = !0),
                      p(function () {
                        "_lazyCache" in t && delete t._lazyCache;
                      }, 9)),
                      "lazy" == t.loading && O--;
                  }, !0);
              }),
              Y = function (t) {
                if (!t._lazyRace) {
                  var e,
                    i = I.test(t.nodeName),
                    a = i && (t[n](s.sizesAttr) || t[n]("sizes")),
                    o = "auto" == a;
                  ((!o && d) ||
                    !i ||
                    (!t[n]("src") && !t.srcset) ||
                    t.complete ||
                    h(t, s.errorClass) ||
                    !h(t, s.lazyClass)) &&
                    ((e = T(t, "lazyunveilread").detail),
                    o && j.updateElem(t, !0, t.offsetWidth),
                    (t._lazyRace = !0),
                    O++,
                    K(t, e, o, a, i));
                }
              },
              Z = A(function () {
                (s.loadMode = 3), $();
              }),
              tt = function () {
                3 == s.loadMode && (s.loadMode = 2), Z();
              },
              et = function () {
                if (!d) {
                  if (o.now() - g < 999) return void p(et, 999);
                  (d = !0), (s.loadMode = 3), $(), c("scroll", tt, !0);
                }
              };
            return {
              _: function () {
                (g = o.now()),
                  (i.elements = e.getElementsByClassName(s.lazyClass)),
                  (r = e.getElementsByClassName(
                    s.lazyClass + " " + s.preloadClass
                  )),
                  c("scroll", $, !0),
                  c("resize", $, !0),
                  t.MutationObserver
                    ? new MutationObserver($).observe(a, {
                        childList: !0,
                        subtree: !0,
                        attributes: !0,
                      })
                    : (a[l]("DOMNodeInserted", $, !0),
                      a[l]("DOMAttrModified", $, !0),
                      setInterval($, 999)),
                  c("hashchange", $, !0),
                  [
                    "focus",
                    "mouseover",
                    "click",
                    "load",
                    "transitionend",
                    "animationend",
                    "webkitAnimationEnd",
                  ].forEach(function (t) {
                    e[l](t, $, !0);
                  }),
                  /d$|^c/.test(e.readyState)
                    ? et()
                    : (c("load", et), e[l]("DOMContentLoaded", $), p(et, 2e4)),
                  i.elements.length ? (G(), S._lsFlush()) : $();
              },
              checkElems: $,
              unveil: Y,
              _aLSL: tt,
            };
          })(),
          j = (function () {
            var t,
              i = z(function (t, e, i, s) {
                var a, o, r;
                if (
                  ((t._lazysizesWidth = s),
                  (s += "px"),
                  t.setAttribute("sizes", s),
                  f.test(e.nodeName || ""))
                )
                  for (
                    o = 0, r = (a = e.getElementsByTagName("source")).length;
                    o < r;
                    o++
                  )
                    a[o].setAttribute("sizes", s);
                i.detail.dataAttr || _(t, i.detail);
              }),
              a = function (t, e, s) {
                var a,
                  o = t.parentNode;
                o &&
                  ((s = C(t, o, s)),
                  (a = T(t, "lazybeforesizes", { width: s, dataAttr: !!e }))
                    .defaultPrevented ||
                    ((s = a.detail.width) &&
                      s !== t._lazysizesWidth &&
                      i(t, o, a, s)));
              },
              o = A(function () {
                var e,
                  i = t.length;
                if (i) for (e = 0; e < i; e++) a(t[e]);
              });
            return {
              _: function () {
                (t = e.getElementsByClassName(s.autosizesClass)),
                  c("resize", o);
              },
              checkElems: o,
              updateElem: a,
            };
          })(),
          Q = function () {
            Q.i || ((Q.i = !0), j._(), k._());
          };
        return (i = {
          cfg: s,
          autoSizer: j,
          loader: k,
          init: Q,
          uP: _,
          aC: y,
          rC: v,
          hC: h,
          fire: T,
          gW: C,
          rAF: S,
        });
      }
    })(t, t.document);
    (t.lazySizes = i),
      "object" == typeof module && module.exports && (module.exports = i);
  })(window),
  (function (t, e) {
    var i = function () {
      e(t.lazySizes), t.removeEventListener("lazyunveilread", i, !0);
    };
    (e = e.bind(null, t, t.document)),
      "object" == typeof module && module.exports
        ? e(require("lazysizes"))
        : t.lazySizes
        ? i()
        : t.addEventListener("lazyunveilread", i, !0);
  })(window, function (t, e, i) {
    "use strict";
    function s(e, i) {
      var s,
        a,
        o,
        r,
        l = t.getComputedStyle(e);
      for (s in ((a = e.parentNode),
      (r = { isPicture: !(!a || !d.test(a.nodeName || "")) }),
      (o = function (t, i) {
        var s = e.getAttribute("data-" + t);
        if (!s) {
          var a = l.getPropertyValue("--ls-" + t);
          a && (s = a.trim());
        }
        if (s) {
          if ("true" == s) s = !0;
          else if ("false" == s) s = !1;
          else if (p.test(s)) s = parseFloat(s);
          else if ("function" == typeof n[t]) s = n[t](e, s);
          else if (g.test(s))
            try {
              s = JSON.parse(s);
            } catch (t) {}
          r[t] = s;
        } else
          t in n && "function" != typeof n[t]
            ? (r[t] = n[t])
            : i && "function" == typeof n[t] && (r[t] = n[t](e, s));
      }),
      n))
        o(s);
      return (
        i.replace(m, function (t, e) {
          e in r || o(e, !0);
        }),
        r
      );
    }
    function a(t, i, s) {
      var a = 0,
        o = 0,
        r = s;
      if (t) {
        if ("container" === i.ratio) {
          for (a = r.scrollWidth, o = r.scrollHeight; !((a && o) || r === e); )
            (a = (r = r.parentNode).scrollWidth), (o = r.scrollHeight);
          a && o && (i.ratio = o / a);
        }
        (t = (function (t, e) {
          var i = [];
          return (
            (i.srcset = []),
            e.absUrl && (h.setAttribute("href", t), (t = h.href)),
            (t = ((e.prefix || "") + t + (e.postfix || "")).replace(
              m,
              function (t, i) {
                return c[typeof e[i]] ? e[i] : t;
              }
            )),
            e.widths.forEach(function (s) {
              var a = e.widthmap[s] || s,
                o = e.aspectratio || e.ratio,
                r = !e.aspectratio && n.traditionalRatio,
                l = {
                  u: t
                    .replace(u, a)
                    .replace(
                      f,
                      o ? (r ? Math.round(s * o) : Math.round(s / o)) : ""
                    ),
                  w: s,
                };
              i.push(l), i.srcset.push((l.c = l.u + " " + s + "w"));
            }),
            i
          );
        })(t, i)),
          (t.isPicture = i.isPicture),
          v && "IMG" == s.nodeName.toUpperCase()
            ? s.removeAttribute(l.srcsetAttr)
            : s.setAttribute(l.srcsetAttr, t.srcset.join(", ")),
          Object.defineProperty(s, "_lazyrias", { value: t, writable: !0 });
      }
    }
    function o(t, e) {
      var a = s(t, e);
      return (
        n.modifyOptions.call(t, { target: t, details: a, detail: a }),
        i.fire(t, "lazyriasmodifyoptions", a),
        a
      );
    }
    function r(t) {
      return (
        t.getAttribute(t.getAttribute("data-srcattr") || n.srcAttr) ||
        t.getAttribute(l.srcsetAttr) ||
        t.getAttribute(l.srcAttr) ||
        t.getAttribute("data-pfsrcset") ||
        ""
      );
    }
    var l,
      n,
      c = { string: 1, number: 1 },
      p = /^\-*\+*\d+\.*\d*$/,
      d = /^picture$/i,
      u = /\s*\{\s*width\s*\}\s*/i,
      f = /\s*\{\s*height\s*\}\s*/i,
      m = /\s*\{\s*([a-z0-9]+)\s*\}\s*/gi,
      g = /^\[.*\]|\{.*\}$/,
      b = /^(?:auto|\d+(px)?)$/,
      h = e.createElement("a"),
      y = e.createElement("img"),
      v = "srcset" in y && !("sizes" in y),
      w = !!t.HTMLPictureElement && !v;
    !(function () {
      var e,
        s = {
          prefix: "",
          postfix: "",
          srcAttr: "data-src",
          absUrl: !1,
          modifyOptions: function () {},
          widthmap: {},
          ratio: !1,
          traditionalRatio: !1,
          aspectratio: !1,
        };
      for (e in ((l = (i && i.cfg) || t.lazySizesConfig) ||
        ((l = {}), (t.lazySizesConfig = l)),
      l.supportsType ||
        (l.supportsType = function (t) {
          return !t;
        }),
      l.rias || (l.rias = {}),
      "widths" in (n = l.rias) ||
        ((n.widths = []),
        (function (t) {
          for (var e, i = 0; !e || e < 3e3; )
            (i += 5) > 30 && (i += 1), (e = 36 * i), t.push(e);
        })(n.widths)),
      s))
        e in n || (n[e] = s[e]);
    })(),
      addEventListener(
        "lazybeforesizes",
        function (t) {
          var e, s, c, p, d, f, m, g, h, y, v, _, P;
          if (
            t.detail.instance == i &&
            ((e = t.target),
            t.detail.dataAttr &&
              !t.defaultPrevented &&
              !n.disabled &&
              (h = e.getAttribute(l.sizesAttr) || e.getAttribute("sizes")) &&
              b.test(h))
          ) {
            if (
              ((c = o(e, (s = r(e)))),
              (v = u.test(c.prefix) || u.test(c.postfix)),
              c.isPicture && (p = e.parentNode))
            )
              for (
                f = 0, m = (d = p.getElementsByTagName("source")).length;
                f < m;
                f++
              )
                (v || u.test((g = r(d[f])))) && (a(g, c, d[f]), (_ = !0));
            v || u.test(s)
              ? (a(s, c, e), (_ = !0))
              : _ &&
                (((P = []).srcset = []),
                (P.isPicture = !0),
                Object.defineProperty(e, "_lazyrias", {
                  value: P,
                  writable: !0,
                })),
              _ &&
                (w
                  ? e.removeAttribute(l.srcAttr)
                  : "auto" != h &&
                    ((y = { width: parseInt(h, 10) }),
                    T({ target: e, detail: y })));
          }
        },
        !0
      );
    var T = (function () {
      var s = function (t, e) {
          return t.w - e.w;
        },
        a = function (t, e) {
          var s;
          return (
            !t._lazyrias &&
              i.pWS &&
              (s = i.pWS(t.getAttribute(l.srcsetAttr || ""))).length &&
              (Object.defineProperty(t, "_lazyrias", {
                value: s,
                writable: !0,
              }),
              e &&
                t.parentNode &&
                (s.isPicture =
                  "PICTURE" == t.parentNode.nodeName.toUpperCase())),
            t._lazyrias
          );
        },
        o = function (e) {
          var s = t.devicePixelRatio || 1,
            a = i.getX && i.getX(e);
          return Math.min(a || s, 2.4, s);
        },
        r = function (e, i) {
          var r, l, n, c, p, d;
          if ((p = e._lazyrias).isPicture && t.matchMedia)
            for (
              l = 0,
                n = (r = e.parentNode.getElementsByTagName("source")).length;
              l < n;
              l++
            )
              if (
                a(r[l]) &&
                !r[l].getAttribute("type") &&
                (!(c = r[l].getAttribute("media")) ||
                  (matchMedia(c) || {}).matches)
              ) {
                p = r[l]._lazyrias;
                break;
              }
          return (
            (!p.w || p.w < i) &&
              ((p.w = i),
              (p.d = o(e)),
              (d = (function (t) {
                for (var e, i, s = t.length, a = t[s - 1], o = 0; o < s; o++)
                  if ((((a = t[o]).d = a.w / t.w), a.d >= t.d)) {
                    !a.cached &&
                      (e = t[o - 1]) &&
                      e.d > t.d - 0.13 * Math.pow(t.d, 2.2) &&
                      ((i = Math.pow(e.d - 0.6, 1.6)),
                      e.cached && (e.d += 0.15 * i),
                      e.d + (a.d - t.d) * i > t.d && (a = e));
                    break;
                  }
                return a;
              })(p.sort(s)))),
            d
          );
        },
        n = function (s) {
          if (s.detail.instance == i) {
            var o,
              c = s.target;
            if (!v && (t.respimage || t.picturefill || lazySizesConfig.pf))
              return void e.removeEventListener("lazybeforesizes", n);
            ("_lazyrias" in c || (s.detail.dataAttr && a(c, !0))) &&
              (o = r(c, s.detail.width)) &&
              o.u &&
              c._lazyrias.cur != o.u &&
              ((c._lazyrias.cur = o.u),
              (o.cached = !0),
              i.rAF(function () {
                c.setAttribute(l.srcAttr, o.u), c.setAttribute("src", o.u);
              }));
          }
        };
      return (
        w ? (n = function () {}) : addEventListener("lazybeforesizes", n), n
      );
    })();
  })),
  "undefined" != typeof theme &&
    theme.hasOwnProperty("settings") &&
    (theme.settings.predictiveSearchEnabled = !1);
var boostPFSFilterConfig = {
  general: {
    limit: boostPFSThemeConfig.custom.products_per_page,
    loadProductFirst: !0,
    showPlaceholderProductList: !0,
    placeholderProductPerRow: 3,
    placeholderProductGridItemClass:
      "boost-pfs-filter-product-item boost-pfs-filter-product-item-grid boost-pfs-filter-grid-width-3 boost-pfs-filter-grid-width-mb-2",
    enableOTP: !0,
    aspect_ratio: boostPFSThemeConfig.custom.aspect_ratio,
    cropImagePossitionEqualHeight: boostPFSThemeConfig.custom.product_img_crop,
    defaultDisplay: boostPFSThemeConfig.custom.product_item_type,
    selectOptionContainer: ".boost-pfs-filter-product-item-image",
  },
  selector: { otpButtons: ".boost-pfs-filter-product-item-image" },
};
function buildWishlistHeroButton(t) {
  try {
    let l = t;
    var e = l.images ? l.images[1] : "",
      i = l.title,
      s = "https://" + window.Shopify.shop + l.url,
      a = l.price / 100,
      o = l.variants[0].id,
      r = l.variants[0];
    l.variants.forEach(function (t) {
      t.id == o &&
        ((r = t).url && (s = r.url),
        r.name && (i = r.name),
        (a = r.price / 100));
    });
    let n = document.createElement("div");
    return (
      n.classList.add("wishlist-hero-bc-button"),
      n.classList.add("wishlisthero-bc-inline"),
      n.setAttribute("data-wlh-id", l.id),
      n.setAttribute("data-wlh-link", s),
      n.setAttribute("data-wlh-variantId", r.id),
      n.setAttribute("data-wlh-price", a),
      n.setAttribute("data-wlh-name", i),
      n.setAttribute("data-wlh-image", e),
      n.setAttribute("data-wlh-mode", "icon_only"),
      n.outerHTML
    );
  } catch (t) {
    console.log(t);
  }
}
function awaitWhishlist() {
  null !== document.querySelector(".wishlist-hero-bc-button")
    ? document
        .querySelectorAll(".wishlist-hero-bc-button")
        .forEach(function (t) {
          setTimeout(function () {
            var e = new CustomEvent("wishlist-hero-add-to-custom-element", {
              detail: t,
            });
            document.dispatchEvent(e);
          }, 2e3);
        })
    : setTimeout(function () {
        awaitWhishlist();
      }, 10);
}
!(function () {
  var t = !1,
    e = !1,
    i = !1,
    s = [],
    a =
      "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==",
    o = [180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048];
  function r(a) {
    if (
      ((e = !a.available),
      (t = a.compare_at_price_min > a.price_min),
      (i = a.price_min != a.price_max),
      (s = a.images_info),
      a.variants[0],
      null !== Utils.getParam("variant") && "" != Utils.getParam("variant"))
    ) {
      var o = a.variants.filter(function (t) {
        return t.id == Utils.getParam("variant");
      });
      void 0 !== o[0] && o[0];
    } else
      for (var r = 0; r < a.variants.length; r++)
        if (a.variants[r].available) {
          a.variants[r];
          break;
        }
    return a;
  }
  function l(t) {
    for (
      var e = "",
        i = o,
        r = 100,
        l = "",
        n = "",
        c = t.title,
        p = "",
        d =
          !Utils.isMobile() &&
          s.length > 1 &&
          boostPFSThemeConfig.custom.hasOwnProperty("active_image_swap") &&
          1 == boostPFSThemeConfig.custom.active_image_swap,
        u = 0;
      u < i.length;
      u++
    )
      (l += Utils.getFeaturedImage(s, i[u] + "x") + " " + i[u] + "w"),
        (n += i[u]),
        d &&
          (p += Utils.optimizeImage(s[1].src, i[u] + "x") + " " + i[u] + "w"),
        u < i.length - 1 && ((l += ", "), (n += ", "), d && (p += ", "));
    return (
      s.length > 0 && (r = (1 / (s[0].width / s[0].height)) * 100),
      (e += '<a href="{{itemUrl}}" data-variantid="'),
      (e += t.variants[0].id),
      (e += '" class="boost-pfs-filter-product-item-image-link" '),
      (e += 'style="padding-top:' + r + '%;">'),
      (e +=
        '<img class="boost-pfs-filter-product-item-main-image lazyload Image--lazyLoad"data-srcset="' +
        l +
        '" data-src="' +
        Utils.getFeaturedImage(s, i[2] + "x") +
        '" data-widths="[' +
        n +
        ']" data-sizes="auto" src="' +
        a +
        '" alt="' +
        c +
        '"  '),
      d &&
        (e +=
          ' data-img-flip-src="' +
          Utils.optimizeImage(s[1].src, i[2] + "x") +
          '" data-img-flip-srcset="' +
          p +
          '" '),
      e + "/></a>"
    );
  }
  function n(t) {
    var e = "";
    return (
      boostPFSThemeConfig.custom.hasOwnProperty("show_vendor") &&
        1 == boostPFSThemeConfig.custom.show_vendor &&
        (e = boostPFSTemplate.vendorHtml),
      e
    );
  }
  function c(e) {
    var s = "";
    return (
      boostPFSThemeConfig.custom.hasOwnProperty("show_price") &&
        boostPFSThemeConfig.custom.show_price &&
        ((s = '<p class="boost-pfs-filter-product-item-price">'),
        t
          ? ((s +=
              '<span class="boost-pfs-filter-product-item-sale-price">' +
              Utils.formatMoney(e.price_min) +
              "</span>"),
            (s += "<s>" + Utils.formatMoney(e.compare_at_price_min) + "</s> "))
          : (i &&
              (s +=
                '<span class="boost-pfs-filter-product-item-price-from-text">' +
                boostPFSThemeConfig.label_basic.from +
                " </span>"),
            (s +=
              '<span class="boost-pfs-filter-product-item-regular-price">' +
              Utils.formatMoney(e.price_min) +
              "</span>")),
        (s += "</p>")),
      s
    );
  }
  function p(i) {
    var s = "";
    boostPFSThemeConfig.custom.hasOwnProperty("sold_out_enable") &&
      boostPFSThemeConfig.custom.sold_out_enable &&
      e &&
      (s = boostPFSTemplate.soldOutLabelHtml.replace(/{{style}}/g, ""));
    var a = "",
      o = "";
    return (
      boostPFSThemeConfig.custom.sale_label_enable &&
        t &&
        !e &&
        ("sale_percent" == boostPFSThemeConfig.custom.sale_label_display &&
          (o = Math.round(
            (100 * (i.compare_at_price_min - i.price_min)) /
              i.compare_at_price_max
          )),
        (a = boostPFSTemplate.saleLabelHtml.replace(/{{style}}/g, "")),
        (a = boostPFSTemplate.saleLabelHtml.replace(
          /percent/g,
          "-" + o + "%"
        ))),
      s + a
    );
  }
  function d(t, e) {
    if (boostPFSThemeConfig.custom.tag_label_enable) {
      if (e) {
        var i = "";
        if (t.tags)
          for (var s = 0; s < t.tags.length; s++) {
            var a = t.tags[s];
            -1 !== a.indexOf("pfs:label") &&
              (i += boostPFSTemplate.tagLabelHtml.replace(
                /{{labelTag}}/g,
                a.split("pfs:label-")[1]
              ));
          }
      } else if (((i = ""), t.tags))
        for (s = t.tags.length - 1; s >= 0; s--)
          if (-1 !== (a = t.tags[s]).indexOf("pfs:label")) {
            i += boostPFSTemplate.tagLabelHtml.replace(
              /{{labelTag}}/g,
              a.split("pfs:label-")[1]
            );
            break;
          }
      return i;
    }
    return "";
  }
  function u(t, e, i) {
    return i.indexOf(t) === e;
  }
  function f(t) {
    var e = "";
    if (boostPFSThemeConfig.custom.swatch_enable)
      for (
        var i = ["color", "img", "pro_img", "text"], s = 0;
        s < i.length;
        s++
      )
        for (
          var a = boostPFSThemeConfig.custom["swatch_by_" + i[s] + "_apply"]
              .split(",")
              .filter(u),
            o = boostPFSThemeConfig.custom["swatch_by_" + i[s] + "_shape"],
            r = i[s],
            l = 0;
          l < a.length;
          l++
        ) {
          var n = a[l].trim(),
            c = n,
            p = [],
            d = 0,
            f = [],
            m = 4,
            g = Utils.getFeaturedImage(t.images_info, "360x"),
            b = "#ffffff",
            h = "",
            y = "More " + c;
          if (
            void 0 !== t.options_with_values &&
            t.options_with_values.length > 0 &&
            (p = t.options_with_values.filter(function (t) {
              return t.name == n;
            })).length > 0
          ) {
            m > (d = p[0].values.length) && (m = d),
              (f = p[0].values),
              (e +=
                '<ul class="boost-pfs-filter-item-swatch boost-pfs-filter-item-swatch-option' +
                n +
                " boost-pfs-filter-item-swatch-shape-" +
                o +
                " boost-pfs-filter-item-swatch-type-" +
                r +
                '">');
            for (var v = 0; v < m; v++) {
              if (
                ((b = f[v].title),
                (swatchVariant = t.variants[v]),
                (sImageIndex = f[v].image || ""),
                "" != sImageIndex &&
                  (g =
                    Utils.optimizeImage(swatchVariant.image, "360x") + " 360w"),
                r)
              )
                switch (r) {
                  case "img":
                    h = boostPFSAppConfig.general.file_url.replace(
                      /\?/,
                      Utils.slugify(c).replace(/\-/g, "_") +
                        "-" +
                        Utils.slugify(b) +
                        ".png?v="
                    );
                    break;
                  case "pro_img":
                    (h = Utils.getFeaturedImage(t.images_info, "50x")),
                      "" != sImageIndex &&
                        (h = Utils.optimizeImage(t.images[sImageIndex], "50x")),
                      h && h.includes("boost-pfs-no-image") && (h = "");
                    break;
                  default:
                    h = "";
                }
              (e += "<li>"),
                "text" == r
                  ? (e +=
                      '<a aria-label="' +
                      n +
                      ": " +
                      b +
                      '" title="' +
                      b +
                      '" href="' +
                      Utils.buildProductItemUrl(t) +
                      "?variant=" +
                      swatchVariant.id +
                      '">' +
                      b +
                      "</a>")
                  : (boostPFSThemeConfig.custom.show_swatch_tooltip &&
                      (e +=
                        '<div class="boost-pfs-product-item-tooltip">' +
                        b +
                        "</div>"),
                    (e +=
                      '<span tabindex="0" aria-label="' +
                      n +
                      ": " +
                      b +
                      '" style="background-color: ' +
                      b +
                      "; "),
                    (e +=
                      "" != h ? "background-image: url(" + h + ');" ' : '" '),
                    "" != g && (e += 'data-img="' + g + '" '),
                    (e += "></span>")),
                (e += "</li>");
            }
            d > m &&
              ((e += '<li class="boost-pfs-filter-item-swatch-more">'),
              (e +=
                '<a href="{{itemUrl}}" aria-label="' +
                y +
                '" title="' +
                y +
                '">+' +
                (d - m) +
                "</a>"),
              (e += "</li>")),
              (e += "</ul>");
          }
        }
    return e;
  }
  function m(t) {
    var e = "";
    return (
      boostPFSThemeConfig.custom.hasOwnProperty("show_product_review") &&
        1 == boostPFSThemeConfig.custom.show_product_review &&
        (e =
          '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>'),
      e
    );
  }
  function g(t) {
    return !Utils.isMobile() &&
      s.length > 1 &&
      boostPFSThemeConfig.custom.hasOwnProperty("active_image_swap") &&
      1 == boostPFSThemeConfig.custom.active_image_swap
      ? "has-bc-swap-image"
      : "";
  }
  function b(t, e) {
    return "" === t
      ? t
      : "list" === t
      ? Labels.listView || "List view"
      : void 0 === e || 0 === e
      ? Labels.gridView || "Grid view"
      : (Labels.gridViewColumns || "Grid view {{ count }} Columns").replace(
          /{{ count }}/g,
          e
        );
  }
  /* -Boost-formRequest 201538 */
  function formRequest(value) {
    return new Promise((resolve, reject) => {
      var xhr = window.XMLHttpRequest
        ? new XMLHttpRequest()
        : new ActiveXObject("Microsoft.XMLHTTP");
      xhr.open(
        "GET",
        Shopify.routes.root +
          "products/" +
          value +
          "?view=boost-pfs-prod-prices"
      );
      xhr.setRequestHeader("Content-Type", "application/json");
      xhr.onload = () => resolve(xhr.responseText);
      xhr.onerror = () => reject(xhr.statusText);
      xhr.send();
    });
  }
  /* -Boost-formRequest 201538 */
  BoostPFS.inject(this),
    (boostPFSFilterConfig.general.separateRefineByFromFilter = !!(
      jQ(".boost-pfs-filter-tree-h").length &&
      !Utils.isMobile() > 0 &&
      "style-expand" != boostPFSThemeConfig.custom.filter_tree_horizontal_style
    )),
    (Selector.stickyElementDesktop =
      jQ(".boost-pfs-filter-tree-v").length > 0 && !Utils.isMobile()
        ? ".boost-pfs-filter-left-col"
        : ".boost-pfs-filter-tree"),
    (ProductGridItem.prototype.compileTemplate = function (i) {
      i || (i = this.data), (i = r(i));
      var s,
        a,
        o = boostPFSTemplate.productGridItemHtml,
        u = e ? boostPFSTemplate.soldOutClass : "",
        b = t ? boostPFSTemplate.saleClass : "";
      return (
        (o = (o = (o = (o = (o = (o = (o = (o = (o = o.replace(
          /{{soldOutClass}}/g,
          u
        )).replace(/{{saleClass}}/g, b)).replace(
          /{{gridWidthClass}}/g,
          (function () {
            var t = "";
            switch (boostPFSThemeConfig.custom.products_per_row) {
              case 2:
                t = "boost-pfs-filter-grid-width-2";
                break;
              case 3:
                t = "boost-pfs-filter-grid-width-3";
                break;
              case 5:
                t = "boost-pfs-filter-grid-width-5";
                break;
              case 6:
                t = "boost-pfs-filter-grid-width-6";
                break;
              default:
                t = "boost-pfs-filter-grid-width-4";
            }
            switch (boostPFSThemeConfig.custom.products_per_row_m) {
              case 1:
                t += " boost-pfs-filter-grid-width-mb-1";
                break;
              case 3:
                t += " boost-pfs-filter-grid-width-mb-3";
                break;
              default:
                t += " boost-pfs-filter-grid-width-mb-2";
            }
            return t;
          })()
        )).replace(/{{itemLabels}}/g, p(i))).replace(
          /{{itemTagLabels}}/g,
          d(i, !1)
        )).replace(/{{itemImages}}/g, l(i))).replace(
          /{{itemPrice}}/g,
          c(i)
        )).replace(
          /{{itemButton}}/g,
          ((s = i.variants[0].available ? "" : "disabled"),
          (a = i.variants[0].available
            ? window.variantStrings.addToCart
            : window.variantStrings.soldOut),
          '<div class="c-product-card__cta"><form method="post" action="/en/cart/add" accept-charset="UTF-8" class="c-product-form" enctype="multipart/form-data" data-form="" data-type="add-to-cart-form" data-product-handle="' +
            i.handle +
            '" novalidate="novalidate"><input type="hidden" name="form_type" value="product"><input type="hidden" name="utf8" value="✓"><input type="hidden" name="quantity" value="1"><input type="hidden" name="id" value="' +
            i.variants[0].id +
            '"><button data-form-submit type="submit" name="add" class="c-button c-button--full u-b1 u-uppercase js-go-cart-add-to-cart"' +
            s +
            "><span data-form-submit-label> " +
            a +
            "</span></button></form></div>")
        )).replace(
          /{{itemType}}/g,
          (function (t) {
            var e = "";
            return (
              t.metafields.length > 0 &&
                (e =
                  '<p class="c-product-card__type u-b4 u-fw-700 u-uppercase">' +
                  t.metafields[0].value +
                  "</p>"),
              e
            );
          })(i)
        )),
        ("undefined" == typeof Integration ||
          ("undefined" != typeof Integration &&
            "function" == typeof Integration.hascompileTemplate &&
            !Integration.hascompileTemplate("reviews"))) &&
          (o = o.replace(/{{itemReviews}}/g, m())),
        (o = (o = (o = (o = (o = (o = (o = (o = o.replace(
          /{{itemVendor}}/g,
          n()
        )).replace(/{{itemActiveSwapClass}}/g, g())).replace(
          /{{itemSwatches}}/g,
          f(i)
        )).replace(
          /{{itemWishlistButton}}/g,
          buildWishlistHeroButton(i)
        )).replace(/{{itemId}}/g, i.id)).replace(
          /{{itemTitle}}/g,
          i.title
        )).replace(/{{itemHandle}}/g, i.handle)).replace(
          /{{itemVendorLabel}}/g,
          i.vendor
        )).replace(/{{itemUrl}}/g, Utils.buildProductItemUrlWithVariant(i))
      );
    }),
    (ProductListItem.prototype.compileTemplate = function (i) {
      i || (i = this.data), (i = r(i));
      var s = boostPFSTemplate.productListItemHtml,
        a = e ? boostPFSTemplate.soldOutClass : "",
        o = t ? boostPFSTemplate.saleClass : "";
      (s = (s = (s = (s = (s = s.replace(/{{soldOutClass}}/g, a)).replace(
        /{{saleClass}}/g,
        o
      )).replace(/{{itemLabels}}/g, p(i))).replace(
        /{{itemTagLabels}}/g,
        d(i, !1)
      )).replace(/{{itemImages}}/g, l(i))),
        ("undefined" == typeof Integration ||
          ("undefined" != typeof Integration &&
            "function" == typeof Integration.hascompileTemplate &&
            !Integration.hascompileTemplate("reviews"))) &&
          (s = s.replace(/{{itemReviews}}/g, m())),
        (s = s.replace(/{{itemVendor}}/g, n()));
      var u = c(i);
      s = s.replace(/{{itemPrice}}/g, u);
      var b = "";
      return (
        null != i.body_html &&
          (b =
            (b = jQ("<p>" + i.body_html + "</p>").text()).split(" ").length > 35
              ? b.split(" ").splice(0, 35).join(" ") + "..."
              : b.split(" ").splice(0, 35).join(" ")),
        (s = (s = (s = (s = (s = (s = (s = s.replace(
          /{{itemDescription}}/g,
          b
        )).replace(/{{itemActiveSwapClass}}/g, g())).replace(
          /{{itemSwatches}}/g,
          f(i)
        )).replace(
          /{{itemWishlistButton}}/g,
          buildWishlistHeroButton(i)
        )).replace(/{{itemTitle}}/g, i.title)).replace(
          /{{itemVendorLabel}}/g,
          i.vendor
        )).replace(
          /{{itemUrl}}/g,
          Utils.buildProductItemUrlWithVariant(i)
        )).replace(/{{itemId}}/g, i.id)
      );
    }),
    (ProductPaginationDefault.prototype.compileTemplate = function (t) {
      t || (t = this.totalProduct);
      var e = parseInt(Utils.stripHtml(Globals.queryParams.page)),
        i = Math.ceil(t / Utils.stripHtml(Globals.queryParams.limit));
      if (((e && !isNaN(e)) || (e = 1), i <= 1)) return "";
      var s = boostPFSTemplate.paginateHtml,
        a =
          e > 1
            ? boostPFSTemplate.previousActiveHtml
            : boostPFSTemplate.previousDisabledHtml;
      (a = a.replace(/{{itemUrl}}/g, Utils.buildToolbarLink("page", e, e - 1))),
        (s = s.replace(/{{previous}}/g, a));
      var o =
        e < i
          ? boostPFSTemplate.nextActiveHtml
          : boostPFSTemplate.nextDisabledHtml;
      (o = o.replace(/{{itemUrl}}/g, Utils.buildToolbarLink("page", e, e + 1))),
        (s = s.replace(/{{next}}/g, o));
      for (var r = [], l = e - 1; l > e - 3 && l > 0; l--) r.unshift(l);
      e - 4 > 0 && r.unshift("..."), e - 4 >= 0 && r.unshift(1), r.push(e);
      for (var n = [], c = e + 1; c < e + 3 && c <= i; c++) n.push(c);
      e + 3 < i && n.push("..."), e + 3 <= i && n.push(i);
      for (var p = "", d = r.concat(n), u = 0; u < d.length; u++)
        "..." == d[u]
          ? (p += boostPFSTemplate.pageItemRemainHtml)
          : (p +=
              d[u] == e
                ? boostPFSTemplate.pageItemSelectedHtml
                : boostPFSTemplate.pageItemHtml),
          (p = (p = p.replace(/{{itemTitle}}/g, d[u])).replace(
            /{{itemUrl}}/g,
            Utils.buildToolbarLink("page", e, d[u])
          ));
      return s.replace(/{{pageItems}}/g, p);
    }),
    (ProductSorting.prototype.compileTemplate = function () {
      var t = "";
      if (
        boostPFSThemeConfig.custom.show_sort_by &&
        boostPFSTemplate.hasOwnProperty("sortingHtml")
      ) {
        var e = Utils.getSortingList();
        if (e) {
          var i = Utils.stripHtml(Globals.queryParams.sort) || "",
            s = "";
          for (var a in e)
            (activeClass = ""),
              i == a && (activeClass = "boost-pfs-filter-sort-item-active"),
              (s +=
                '<li aria-label="' +
                e[a] +
                '"><a href="#" data-sort="' +
                a +
                '" class="' +
                activeClass +
                '"  title="' +
                e[a] +
                '" aria-label="' +
                e[a] +
                '">' +
                e[a] +
                "</a></li>");
          t = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, s);
        }
      }
      return t;
    }),
    (ProductSorting.prototype.render = function () {
      jQ(Selector.topSorting).html(this.compileTemplate()),
        jQ(".boost-pfs-filter-custom-sorting").hasClass(
          "boost-pfs-filter-sort-active"
        ) &&
          jQ(".boost-pfs-filter-custom-sorting").toggleClass(
            "boost-pfs-filter-sort-active"
          );
      var t,
        e = Utils.stripHtml(Globals.queryParams.sort) || "",
        i = Utils.getSortingList();
      (t = e.length > 0 && i && i[e] ? i[e] : Labels.sorting_heading),
        jQ(".boost-pfs-filter-custom-sorting button span span").text(t);
    }),
    (ProductSorting.prototype.bindEvents = function () {
      jQ(".boost-pfs-filter-filter-dropdown a").click(function (t) {
        t.preventDefault(),
          FilterApi.setParam("sort", jQ(this).data("sort")),
          FilterApi.setParam("page", 1),
          FilterApi.applyFilter("sort");
      }),
        jQ(".boost-pfs-filter-custom-sorting > button").click(function () {
          jQ(".boost-pfs-filter-filter-dropdown")
            .toggle()
            .parent()
            .toggleClass("boost-pfs-filter-sort-active");
        }),
        jQ(Selector.filterTreeMobileButton).click(function () {
          jQ(
            ".boost-pfs-filter-top-sorting-mobile .boost-pfs-filter-filter-dropdown"
          ).hide();
        }),
        jQ(document).on("click", function (t) {
          0 ===
            jQ(t.target)
              .parents(".boost-pfs-filter-top-sorting")
              .find(".boost-pfs-filter-filter-dropdown").length &&
            jQ(".boost-pfs-filter-filter-dropdown")
              .hide()
              .parent()
              .removeClass("boost-pfs-filter-sort-active");
        });
    }),
    (ProductDisplayType.prototype.compileTemplate = function () {
      var t = "<span>" + boostPFSThemeConfig.label.toolbar_viewas + "</span>";
      return (
        "grid" == boostPFSThemeConfig.custom.product_item_type
          ? "view_as_type_list_grid_multi_col" !=
              boostPFSThemeConfig.custom.view_as_type || Utils.isMobile()
            ? ((t +=
                '<a href="' +
                Utils.buildToolbarLink("display", "list", "grid") +
                '" title="' +
                b("grid") +
                '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid" data-view="grid"><span class="icon-fallback-text"></span></a>'),
              (t +=
                '<a href="' +
                Utils.buildToolbarLink("display", "grid", "list") +
                '" title="' +
                b("list") +
                '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"></span></a>'))
            : ((t +=
                '<a href="' +
                Utils.buildToolbarLink("display", "grid", "list") +
                '" title="' +
                b("list") +
                '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"></span></a>'),
              (t +=
                '<a href="' +
                Utils.buildToolbarLink("display", "list", "grid") +
                '" title="' +
                b("grid", 2) +
                '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-2" data-view="grid-2"><span class="icon-fallback-text"></span></a>'),
              (t +=
                '<a href="' +
                Utils.buildToolbarLink("display", "list", "grid") +
                '" title="' +
                b("grid", 3) +
                '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-3" data-view="grid-3"><span class="icon-fallback-text"></span></a>'),
              (t +=
                '<a href="' +
                Utils.buildToolbarLink("display", "list", "grid") +
                '" title="' +
                b("grid", 4) +
                '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-4" data-view="grid-4"><span class="icon-fallback-text"></span></a>'),
              (t +=
                '<a href="' +
                Utils.buildToolbarLink("display", "list", "grid") +
                '" title="' +
                b("grid", 5) +
                '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-5" data-view="grid-5"><span class="icon-fallback-text"></span></a>'),
              (t +=
                '<a href="' +
                Utils.buildToolbarLink("display", "list", "grid") +
                '" title="' +
                b("grid", 6) +
                '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-6" data-view="grid-6"><span class="icon-fallback-text"></span></a>'))
          : "view_as_type_list_grid_multi_col" !=
              boostPFSThemeConfig.custom.view_as_type || Utils.isMobile()
          ? ((t +=
              '<a href="' +
              Utils.buildToolbarLink("display", "grid", "list") +
              '" title="' +
              b("list") +
              '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"></span></a>'),
            (t +=
              '<a href="' +
              Utils.buildToolbarLink("display", "list", "grid") +
              '" title="' +
              b("grid") +
              '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid" data-view="grid"><span class="icon-fallback-text"></span></a>'))
          : ((t +=
              '<a href="' +
              Utils.buildToolbarLink("display", "grid", "list") +
              '" title="' +
              b("list") +
              '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"></span></a>'),
            (t +=
              '<a href="' +
              Utils.buildToolbarLink("display", "list", "grid") +
              '" title="' +
              b("grid", 2) +
              '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-2" data-view="grid-2"><span class="icon-fallback-text"></span></a>'),
            (t +=
              '<a href="' +
              Utils.buildToolbarLink("display", "list", "grid") +
              '" title="' +
              b("grid", 3) +
              '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-3" data-view="grid-3"><span class="icon-fallback-text"></span></a>'),
            (t +=
              '<a href="' +
              Utils.buildToolbarLink("display", "list", "grid") +
              '" title="' +
              b("grid", 4) +
              '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-4" data-view="grid-4"><span class="icon-fallback-text"></span></a>'),
            (t +=
              '<a href="' +
              Utils.buildToolbarLink("display", "list", "grid") +
              '" title="' +
              b("grid", 5) +
              '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-5" data-view="grid-5"><span class="icon-fallback-text"></span></a>'),
            (t +=
              '<a href="' +
              Utils.buildToolbarLink("display", "list", "grid") +
              '" title="' +
              b("grid", 6) +
              '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-6" data-view="grid-6"><span class="icon-fallback-text"></span></a>')),
        t.replace(/{{class.productDisplayType}}/g, Class.productDisplayType)
      );
    });
  var h = ProductDisplayType.prototype.render;
  (ProductDisplayType.prototype.render = function () {
    if ((h.call(this), this.$element.length))
      if (
        (this.$element
          .find(this.selector.productDisplayTypeList)
          .removeClass("active"),
        this.$element
          .find(this.selector.productDisplayTypeGrid)
          .removeClass("active"),
        "list" == Utils.stripHtml(Globals.queryParams.display))
      )
        this.$element
          .find(this.selector.productDisplayTypeList)
          .addClass("active");
      else if ("grid" == Utils.stripHtml(Globals.queryParams.display))
        if (
          "view_as_type_list_grid_multi_col" !=
            boostPFSThemeConfig.custom.view_as_type ||
          Utils.isMobile()
        )
          this.$element
            .find(this.selector.productDisplayTypeGrid)
            .addClass("active");
        else {
          var t = boostPFSThemeConfig.custom.products_per_row;
          this.$element
            .find(this.selector.productDisplayTypeGrid)
            .each(function () {
              var e = jQ(this).parent(),
                i = jQ(".boost-pfs-filter-top-display-type")
                  .attr("class")
                  .split(" "),
                s = i[i.length - 1],
                a = s.split("-")[s.split("-").length - 1];
              if (
                e.hasClass("boost-pfs-filter-view-as-click") &&
                jQ(this).data("view") == s
              ) {
                if (
                  (jQ(this).addClass("active"),
                  jQ(".boost-pfs-filter-product-item").length > 0)
                ) {
                  for (
                    var o = jQ(".boost-pfs-filter-product-item")
                        .attr("class")
                        .split(" "),
                      r = "",
                      l = 0;
                    l < o.length;
                    l++
                  )
                    if (o[l].match(/(^|\s)boost-pfs-filter-grid-width-\S+/g)) {
                      r = o[l];
                      break;
                    }
                  jQ(".boost-pfs-filter-product-item").removeClass(r),
                    jQ(".boost-pfs-filter-product-item").addClass(
                      "boost-pfs-filter-grid-width-" + a
                    );
                }
              } else e.hasClass("boost-pfs-filter-view-as-click") || jQ(this).data("view").split("-")[1] != t || jQ(this).addClass("active");
            });
        }
  }),
    (ProductLimit.prototype.compileTemplate = function () {
      var t = "";
      if (
        boostPFSThemeConfig.custom.show_limit &&
        boostPFSTemplate.hasOwnProperty("showLimitHtml")
      ) {
        var e = Settings.getSettingValue("general.showLimitList");
        if ("" != e) {
          var i = "",
            s = e.split(",");
          for (var a in sortingArr)
            i +=
              '<option value="' +
              s[a].trim() +
              '">' +
              s[a].trim() +
              "</option>";
          t = boostPFSTemplate.showLimitHtml.replace(/{{showLimitItems}}/g, i);
        }
      }
      return t;
    }),
    (Breadcrumb.prototype.compileTemplate = function (t) {
      t || (t = this.collectionData);
      var e = "";
      if (boostPFSTemplate.hasOwnProperty("breadcrumbHtml"))
        if (void 0 !== t && t.hasOwnProperty("collection")) {
          var i = t.collection;
          void 0 !== this.collectionTags && null !== this.collectionTags
            ? ((e += boostPFSTemplate.breadcrumbItemLink
                .replace(/{{itemLink}}/g, "/collections/" + i.handle)
                .replace(/{{itemTitle}}/g, i.title)),
              (e += " {{breadcrumbDivider}} "),
              (e += boostPFSTemplate.breadcrumbItemSelected.replace(
                /{{itemTitle}}/g,
                this.collectionTags[0]
              )))
            : (e += boostPFSTemplate.breadcrumbItemSelected.replace(
                /{{itemTitle}}/g,
                i.title
              ));
        } else
          e += boostPFSTemplate.breadcrumbItemSelected.replace(
            /{{itemTitle}}/g,
            Settings.getSettingValue("label.defaultCollectionHeader")
          );
      return e;
    }),
    (ProductList.prototype.afterRender = function (t) {
      t || (t = this.data),
        window.SPR &&
          "function" == typeof window.SPR.initDomEls &&
          "function" == typeof window.SPR.loadBadges &&
          boostPFSThemeConfig.custom.show_product_review &&
          (window.SPR.initDomEls(), window.SPR.loadBadges());
    }),
    (Filter.prototype.afterRender = function (t) {
      t || (t = this.data);
      var e,
        i,
        s =
          t.total_product +
          "<span> " +
          boostPFSThemeConfig.label.items_with_count_other +
          "</span>";
      if (
        (1 == t.total_product &&
          (s =
            t.total_product +
            "<span> " +
            boostPFSThemeConfig.label.items_with_count_one +
            "</span>"),
        0 == t.total_product
          ? jQ(".boost-pfs-filter-default-toolbar-inner").addClass(
              "boost-pfs-filter-toolbar-product-0"
            )
          : jQ(".boost-pfs-filter-default-toolbar-inner").removeClass(
              "boost-pfs-filter-toolbar-product-0"
            ),
        jQ(".boost-pfs-filter-total-product").html(s),
        jQ("body").find(".boost-pfs-filter-skeleton-button").remove(),
        /iPad|iPhone|iPod/.test(navigator.userAgent) &&
          !window.MSStream &&
          Utils.isMobile() &&
          jQ(".boost-pfs-filter-product-item")
            .find("a")
            .on("touchstart", function () {
              isScrolling = !1;
            })
            .on("touchmove", function () {
              isScrolling = !0;
            })
            .on("touchend", function () {
              isScrolling || (window.location = jQ(this).attr("href"));
            }),
        (function (t) {
          if (
            !Utils.isMobile() &&
            boostPFSThemeConfig.custom.hasOwnProperty("active_image_swap") &&
            1 == boostPFSThemeConfig.custom.active_image_swap
          ) {
            var e = "",
              i = "",
              s = "",
              o = "",
              r = "";
            jQ(".boost-pfs-filter-product-item").each(function () {
              var t = jQ(this),
                l = t.find(".boost-pfs-filter-product-item-main-image");
              void 0 !== l.data("img-flip-src") &&
                "" != l.data("img-flip-src") &&
                ((i = l.data("img-flip-src")),
                (e = l.data("img-flip-srcset")),
                (s = l.attr("alt")),
                (o = l.data("widths")),
                (r =
                  '<img class="boost-pfs-filter-product-item-flip-image lazyload Image--lazyLoad"data-srcset="' +
                  e +
                  '" data-src="' +
                  i +
                  '" data-widths="[' +
                  o +
                  ']" data-sizes="auto" src="' +
                  a +
                  '" alt="' +
                  s +
                  '" />'),
                t.find(".boost-pfs-filter-product-item-image-link").append(r));
            });
          }
        })(),
        "list" !== Utils.stripHtml(Globals.queryParams.display) &&
          setTimeout(function () {
            v();
          }, 700),
        jQ(window).resize(function () {
          "list" !== Utils.stripHtml(Globals.queryParams.display) &&
            setTimeout(function () {
              v();
            }, 700);
        }),
        "none" != boostPFSThemeConfig.custom.swatch_change_img &&
          ((e = boostPFSThemeConfig.custom.swatch_change_img),
          jQ(".boost-pfs-filter-item-swatch li span").each(function () {
            var t = jQ(this)
              .parents(".boost-pfs-filter-product-item-inner")
              .find(".boost-pfs-filter-product-item-main-image");
            "hover" == e &&
              jQ(this).hover(function () {
                var e = jQ(this).data("img");
                t.attr("srcset", e);
              }),
              "click" == e &&
                jQ(this).click(function () {
                  var e = jQ(this).data("img");
                  t.attr("srcset", e);
                }),
              jQ(this).focus(function () {
                if (jQ("body").hasClass("boost-pfs-ada")) {
                  var e = jQ(this).data("img");
                  t.attr("srcset", e);
                }
              });
          })),
        (i = jQ(Selector.products).find("[data-boost-image-loading-animation]"))
          .length && i.removeAttr("data-boost-image-loading-animation"),
        boostPFSThemeConfig.custom.hasOwnProperty("layout_type") &&
          "fullwidth" == boostPFSThemeConfig.custom.layout_type &&
          !Utils.isMobile() &&
          jQ("body").addClass("boost-pfs-filter-fullwidth-page"),
        document.addEventListener("scroll", function () {
          jQ(".boost-pfs-filter-tree-h.boost-pfs-filter-stick").length > 0 &&
            jQ(window).width() > 767 &&
            jQ(
              ".boost-pfs-filter-custom-sorting .boost-pfs-filter-filter-dropdown"
            )
              .hide()
              .parent()
              .removeClass("boost-pfs-filter-sort-active");
        }),
        jQ(".site-nav__thumb-menu").length > 0 && Utils.isMobile())
      ) {
        var o = jQ(".site-nav__thumb-menu").height() + 40;
        jQ(".boost-pfs-filter-tree-mobile-button-stick-wrapper")
          .css("bottom", o)
          .addClass("boost-pfs-filter-sticky-bottom"),
          jQ(".boost-pfs-filter-mobile-style1").addClass(
            "boost-pfs-filter-mobile-style1-sticky-bottom"
          );
      }
    });
  var y = ProductDisplayType.prototype._onClickEvent;
  function v(t) {
    var e = -1,
      i = [],
      s = null;
    jQ(".boost-pfs-filter-product-item").each(function (t, a) {
      var o = jQ(a).offset().top;
      (s && s.offset().top === o) || ((s = jQ(a)), e++),
        i[e] || (i[e] = []),
        i[e].push(a);
    });
    for (var a = 0; a < i.length; a++) {
      for (var o = 0, r = (i[a].length, 0); r < i[a].length; r++) {
        var l = i[a][r],
          n = jQ(l).find(".boost-pfs-filter-product-bottom-inner").height();
        o = Math.max(o, n);
      }
      jQ(i[a])
        .find(".boost-pfs-filter-product-bottom-inner")
        .css({ "min-height": o });
    }
    var c = boostPFSFilterConfig.general.aspect_ratio;
    if ("false" != c) {
      var p = boostPFSFilterConfig.general.cropImagePossitionEqualHeight,
        d = jQ(".boost-pfs-filter-product-item").width();
      if ("false" != c && "auto" != c) {
        var u = 0;
        if (
          ((d = jQ(".boost-pfs-filter-product-item").width()),
          "false" != c && "auto" != c && "other" != c)
        )
          var f = boostPFSThemeConfig.custom.aspect_ratio;
        else f = "";
        var m = boostPFSThemeConfig.custom.aspect_ratio_other;
        if ("" == m && "" == f) return null;
        "other" != c
          ? ((f = f.split(":")),
            (u = d * (f = parseInt(f[1]) / parseInt(f[0]))))
          : "" != m &&
            "other" == c &&
            ((m = m.split(":")),
            (u = d * (m = parseInt(m[1]) / parseInt(m[0])))),
          jQ(".boost-pfs-filter-product-item-image-link")
            .css({ "padding-top": u + "px" })
            .addClass("boost-pfs-filter-crop-image-position-" + p);
      }
    }
  }
  (ProductDisplayType.prototype._onClickEvent = function (t) {
    if (
      (y.call(this, t),
      "view_as_type_list_grid_multi_col" ==
        boostPFSThemeConfig.custom.view_as_type && !Utils.isMobile())
    ) {
      jQ(".boost-pfs-filter-top-display-type").addClass(
        "boost-pfs-filter-view-as-click"
      );
      var e = jQ(t.target).data("view");
      (jQ(".boost-pfs-filter-top-display-type")[0].className = jQ(
        ".boost-pfs-filter-top-display-type"
      )[0].className.replace(/(^|\s)grid-\S+/g, "")),
        jQ(".boost-pfs-filter-top-display-type").addClass(e);
    }
  }),
    (ProductListPlaceholder.prototype.render = function () {
      var t =
          this.settings.productsPerRow ||
          this.settings.placeholderProductPerRow,
        e = this.compileTemplate();
      this.$element = [];
      for (var i = 0; i < t; i++) this.$element.push(jQ(e));
      this.isFetchedProductData ? this.setHide() : this.setShow();
    }),
    (ProductListPlaceholder.prototype.compileTemplateExtra = function () {
      var t = boostPFSTemplate.productListPlaceholderHtml,
        e = parseFloat(this.settings.placeholderImageRatio),
        i = e > 0 ? e : 1.4;
      return t
        .replace(
          /{{class.filterProductSkeleton}}/g,
          Class.filterProductSkeleton
        )
        .replace(/{{class.filterSkeleton}}/g, Class.filterSkeleton)
        .replace(/{{class.filterSkeletonText}}/g, Class.filterSkeletonText)
        .replace(/{{paddingTop}}/g, 100 * i);
    }),
    (Array.prototype.insert = function (t, e) {}),
    // Starts Boost 201538
    (ProductList.prototype.afterRender = function (data) {
      if (!data) data = this.data;
      console.log("Product List data: ", data);
      var hasShopifyRoutes =
        Shopify && Shopify.routes && typeof Shopify.routes.root != "undefined";
      var localeURLPart = "";

      if (hasShopifyRoutes) {
        localeURLPart = Shopify.routes.root.replace(/\/$/, "");
      }

      for (var i = 0; i < data.length; i++) {
        let requestReg = formRequest(data[i].handle);
        const prodId = data[i]['id'];
        requestReg
          .then((res_success) => {
            // let res = JSON.parse(res_success);
            const regex = /<span class="money">([^<]+)<\/span>/;
            const match = regex.exec(res_success);
            let productItem = document.querySelector(
              `.boost-pfs-filter-product-item[data-id="${prodId}"]`
            );
            if(productItem.querySelector(".boost-pfs-filter-product-item-regular-price")){
              productItem.querySelector(
                ".boost-pfs-filter-product-item-regular-price"
              ).innerHTML = match[1];
            }
           if(productItem.querySelector(".boost-pfs-filter-product-item-sale-price")){
              productItem.querySelector(
                ".boost-pfs-filter-product-item-sale-price"
              ).innerHTML = match[1];
           }
          })
          .catch((res_error) => {
            console.log("Errorrrrr: ", res_error);
          });
      }
    }),
    // Ends Boost 201538
    jQ(document).ready(function () {
      if (
        (jQ(".boost-pfs-filter-custom-filter-button").on("click", function () {
          jQ("body").toggleClass("boost-pfs-filter-custom-drawer-open");
        }),
        jQ(".boost-pfs-filter-custom-drawer-close").on("click", function () {
          jQ("body").removeClass("boost-pfs-filter-custom-drawer-open");
        }),
        jQ(".boost-pfs-filter-custom-drawer-overlay").on("click", function () {
          jQ("body").removeClass("boost-pfs-filter-custom-drawer-open");
        }),
        jQ(
          ".boost-pfs-filter-custom-drawer-close, .boost-pfs-filter-custom-drawer-overlay"
        ).on("keydown", (t) => {
          !t.target ||
            (13 != t.keyCode && 32 != t.keyCode) ||
            jQ(t.target).click();
        }),
        awaitWhishlist(),
        jQ(".mm-fixed-top").length > 0)
      ) {
        var t = jQ(".mm-fixed-top").height();
        jQ(".boost-pfs-filter-collection-header-wrapper").css("margin-top", t);
      }
    });
})();
